import { fetchUserData } from "../../routes/FetchData";
import { updateUserInfo } from "../../store/actions/userAction";
import { updateLimit } from "../../store/actions/limitAction";
import { useDispatch } from "react-redux";
import Popup from "../common/Popup";
import SumsubWebSdk from "@sumsub/websdk-react";

function VerificationUser({ token, isPopupOpenVerification, setIsPopupOpenVerification }) {
    const dispatch = useDispatch();

    const closePopupVerification = () => {
        setIsPopupOpenVerification(false);
        fetchUserData().then((data) => {
            updateUserInfo(dispatch, data);
            if (data.id) {
                updateLimit(dispatch, data.id);
            }
        });
    };

  

    return (
        <Popup isOpen={isPopupOpenVerification} onClose={closePopupVerification}>
            <SumsubWebSdk
                accessToken={token}
                expirationHandler={() => closePopupVerification}
                config={{
                    lang: 'en',
                }}
                onMessage={(type, payload) => {
                    if (payload?.reviewResult?.reviewAnswer === "GREEN") {
                        updateUserInfo(dispatch, { verif: 1 });
                    }
                }}
                onError={(error) => {
                    console.error('Error:', error);
                }}
            />
        </Popup>
    );
}

export default VerificationUser;